import {
  Avatar,
  Divider,
  FilledInput,
  FormControl,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import { ReactComponent as TabletLogo } from "assets/Svgs/MesuTabletSvg.svg";
import { useState } from "react";
import { Search } from "@mui/icons-material";

import { ReactComponent as BellSvg } from "assets/Svgs/bell.svg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { ReactComponent as TabletAvatarSvg } from "assets/Svgs/avatar_tablet.svg";
import { useNavigate } from "react-router-dom";

import { useBoundStore } from "store/store";
import i18n from "i18n/i18n";

function TabletHeader() {

  const isAdmin = useBoundStore((state) => state.isAdmin);

  const [searchText, setSearchText] = useState("");

  const [profileAnchor, setProfileAnchor] = useState<null | HTMLElement>(null);

  const navigate = useNavigate();

  const logOut = useBoundStore((state) => state.logOut);

  const lang: any = useBoundStore((state) => state.lang);
  const user: any = useBoundStore((state) => state.user);


  return (
    <div className="tabletHeader">
      <div className="flex">
        <div className="logo">
          <TabletLogo />
        </div>
        <div className="searchField">
         
        </div>

        <div>
          <div className="profileMenu">
            <div className={"accountContainer"}>
              <List className={"roundedListItems"} dense={true}>
                <ListItem
                  onClick={(event: any) =>
                    setProfileAnchor(event.currentTarget)
                  }
                >
                  <ListItemAvatar>
                    <Avatar alt={i18n(lang)?.profile} src={user?.image?.url} />
                  </ListItemAvatar>
                </ListItem>
                <Menu
                  className="profile-menu"
                  style={{ marginTop: "-7px" }}
                  anchorEl={profileAnchor}
                
                  anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                  transformOrigin={{ vertical: "top", horizontal: "center" }}
                  keepMounted
                  open={Boolean(profileAnchor)}
                  onClose={() => setProfileAnchor(null)}
                >
                  <MenuItem
                    onClick={() => {
                      setProfileAnchor(null);
                      navigate("/profile");
                    }}
                  >
                    {i18n(lang)?.profile}
                  </MenuItem>
                  <Divider />
                  <MenuItem
                    onClick={() => {
                      navigate("/login");
                      logOut();
                    }}
                  >
                    {"logout"}
                  </MenuItem>
                </Menu>
              </List>
            </div>
          </div>
        </div>

{
   isAdmin ? (

        <div style={{ margin: "0% 0% 0% 2%"}} className="cp" onClick={()=> { navigate("/users")}}>
          {i18n(lang).admin}
        </div> ) : "" }

      </div>
    </div>
  );
}

export default TabletHeader;
